import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { seedDashboard3DrawersIcons } from '../../components/icon/seed-icons';

const rafflesiaD3dPopoverMenus = [
  {
    Icon: AccountCircleIcon,
    titleId: 'rafflesia.menu.account',
    href: '/account',
  },
  {
    Icon: seedDashboard3DrawersIcons.Settings,
    titleId: 'seed.menu.settings',
    href: '/settings',
  },
];

export default rafflesiaD3dPopoverMenus;
